"use client";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FluxLayout } from "./FluxLayout";
import { UserModel } from "../../domain/models/User";
import { userQueryServiceForUsers } from "../../services/users/UserQueryService";
export function FluxLayoutWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    i18n
  } = useTranslation();
  const [currentUser, setCurrentUser] = useState<UserModel | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const loadUserData = async () => {
      try {
        const userResponse = await userQueryServiceForUsers.fetchCurrentUser().catch(error_0 => {
          console.error("Error loading user data:", error_0);
          return null;
        });
        setCurrentUser(userResponse);
      } catch (error) {
        console.error("Error loading data:", error);
        setCurrentUser(null);
      } finally {
        setIsLoaded(true);
      }
    };
    loadUserData();
  }, []);
  return <FluxLayout currentUser={currentUser} locale={i18n.resolvedLanguage ?? i18n.language ?? "fr"} isUserDataLoaded={isLoaded}>
      {children}
    </FluxLayout>;
}